'use client';

export interface StoneInvestmentIntroductionSectionProps {
  title?: string;
  description?: string;
  locale?: string;
  messages?: Record<string, unknown>;
}

/**
 * Stone Investment - Introduction Section
 * 
 * Concept One Design (Exact Match):
 * - Centered text with elegant padding
 * - Serif heading with italic "of"
 * - Vertical divider line
 * - Sans-serif light body text
 * - Light stone background
 */
export function StoneInvestmentIntroductionSection({
  title: titleProp,
  description: descriptionProp,
  messages,
}: StoneInvestmentIntroductionSectionProps) {
  const stoneMessages = (messages?.stone || {}) as Record<string, unknown>;
  const introMessages = (stoneMessages.introduction || {}) as Record<string, string>;

  const title = introMessages.title || titleProp || 'A Tale of Two Worlds';
  const description = introMessages.description || descriptionProp || 'We select homes that tell a story. Whether it is the scent of lavender in a Gordes courtyard or the warm breeze of the Indian Ocean, Stone Investment offers a portfolio of rare character and timeless beauty.';
  const tagline = (stoneMessages as Record<string, string>).introductionTagline || 'Curated properties. Delivered with precision.';

  return (
    <section className="py-20 md:py-32 px-6 md:px-24 bg-stone-50">
      <div className="max-w-3xl mx-auto text-center space-y-10">
        <h2 className="font-serif text-3xl md:text-5xl text-stone-900 leading-tight">
          {title}
        </h2>
        <div className="w-px h-16 bg-stone-300 mx-auto" />
        <p className="font-sans font-light text-stone-500 leading-relaxed text-base md:text-xl">
          {description}
        </p>
        <p className="font-sans text-xs uppercase tracking-[0.3em] text-stone-600 pt-4">
          {tagline}
        </p>
      </div>
    </section>
  );
}
